import { EWorksheetStatus } from '@if/core/types'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props {
  creditApp: CreditApplication
  isUpdateMode?: boolean
}

const CreateContractButton = ({ creditApp, isUpdateMode = false }: Props) => {
  const { t } = useTranslation()
  const isDraft = creditApp.worksheet?.status === EWorksheetStatus.Draft
  let buttonText: string
  if (isUpdateMode) {
    buttonText = t('worksheet.updateContract')
  } else {
    buttonText = creditApp.worksheet != null && !isDraft ? t('worksheet.editWorksheet') : t('worksheet.createContract')
  }
  const navigate = useNavigate()

  return (
    <AsyncActionButton
      fullWidth
      variant="contained"
      onClick={() => navigate(`/credits/${creditApp.financingProgramId}/${creditApp.id}/worksheet`)}
    >
      {buttonText}
    </AsyncActionButton>
  )
}

export default CreateContractButton
